<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <v-row>
        <v-col cols="6" class="py-0">
          <v-row>
            <v-col cols="order-sm6">
              <metric-kpi metric="total_billing" interval="yearly" comparative="this_v_last_mtd" />
            </v-col>
            <v-col cols="6">
              <metric-kpi metric="total_billing" interval="monthly" comparative="this_v_last" />
            </v-col>
            <v-col cols="6">
              <metric-kpi metric="total_billing_non_recurring" interval="monthly" comparative="this_v_last" />
            </v-col>
            <v-col cols="6">
              <metric-kpi metric="total_cancelled_billing" interval="monthly" comparative="this_v_last" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <metric-graph metric="total_billing" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="px-0 pb-0">
          <v-toolbar color="transparent" flat height="55" dense>
            <v-toolbar-title class="pa-0 ml-n1 text--secondary subtitle-1 font-weight-medium">Suscripciones</v-toolbar-title>
          </v-toolbar>
        </v-col>
        <v-col cols="3">
          <metric-kpi metric="total_mrr" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="3">
          <metric-kpi metric="net_growth_mrr" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="3">
          <metric-kpi metric="arpu" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="3">
          <metric-kpi metric="total_cancelled_subscription" interval="monthly" comparative="this_v_last" />
        </v-col>
        <v-col cols="6" class="py-0">
          <v-row>
            <v-col cols="6">
              <metric-kpi metric="new_mrr" interval="monthly" comparative="this_v_last" />
            </v-col>
            <v-col cols="6">
              <metric-kpi metric="expansion_mrr" interval="monthly" comparative="this_v_last" />
            </v-col>
            <v-col cols="6">
              <metric-kpi metric="contraction_mrr" interval="monthly" comparative="this_v_last" />
            </v-col>
            <v-col cols="6">
              <metric-kpi metric="churn_mrr" interval="monthly" comparative="this_v_last" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <metric-graph metric="net_growth_mrr" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="px-0 pb-0">
          <v-toolbar color="transparent" flat height="55" dense>
            <v-toolbar-title class="pa-0 ml-n1 text--secondary subtitle-1 font-weight-medium">Cobranza</v-toolbar-title>
          </v-toolbar>
        </v-col>
        <v-col cols="6">
          <metric-table metric="overdue_billing_recovery_breakdown" />
        </v-col>
        <v-col cols="6" class="py-0">
          <v-row>
            <v-col cols="6">
              <metric-kpi metric="total_receivables_current_due" interval="monthly" comparative="this_v_last" />
            </v-col>
            <v-col cols="6">
              <metric-kpi metric="total_receivables_overdue" interval="monthly" comparative="this_v_last" />
            </v-col>
            <v-col cols="6">
              <metric-kpi metric="total_receivables" interval="monthly" comparative="this_v_last" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import MetricGraph from '@/components/reports/MetricGraph'
import MetricKpi from '@/components/reports/MetricKpi'
import MetricTable from '@/components/reports/MetricTable'
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  components: {
    MetricGraph,
    MetricKpi,
    MetricTable
  },
  mixins: [
    GenericViewMixin
  ]
}
</script>